import { render } from "./PaymentDetail.vue?vue&type=template&id=c6ce174c"
import script from "./PaymentDetail.vue?vue&type=script&lang=js"
export * from "./PaymentDetail.vue?vue&type=script&lang=js"

import "./PaymentDetail.vue?vue&type=style&index=0&id=c6ce174c&lang=less"

import exportComponent from "E:\\H5\\pay_h5_uni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__